import { useSideBarMethods } from 'hooks/useSideBarMethods';

export const useSideBarOptions = role => {
  const { getSideBarTabs } = useSideBarMethods();

  return {
    getSideBarTabs,
  };
};
